import React from 'react';
import findResult, { hasKey } from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';
import urls, { collectionUrl, relativeUrl, startsWithUrl } from '@/constants/urls';
import PanelContainer from '@/components/wrappers/PanelContainer';
import { fetchCollection, updateCollectionProperties } from '../actions';

const CollectionPanelContainer = ({
  canRead,
  children,
  exists,
  isDirty,
  isNew,
  name,
  onChange,
  readErrors,
  readStatus,
  url,
}) => (
  <PanelContainer
    canAccess={canRead}
    entity="collection"
    exists={exists}
    isDirty={isDirty}
    isNew={isNew}
    name={name}
    onChange={onChange}
    readErrors={readErrors}
    readStatus={readStatus}
    url={url}
  >
    {children}
  </PanelContainer>
);

const accessControl = (role, exists, isNew) => {
  const {
    datasets,
  } = role.permissions;
  return (
    {
      exists,
      isNew,
      canRead: exists ? datasets.read : false,
    });
};

const withoutItem = (role, url) => ({
  ...readStates,
  ...accessControl(role, false, !startsWithUrl(url, relativeUrl(urls.COLLECTIONS))),
});

const withItem = (item, role, url) => {
  const isNewExists = hasKey(item, 'isNew');
  const genuineCollectionUrl = startsWithUrl(url, relativeUrl(urls.COLLECTIONS));
  const urlForCollection = isNewExists && !item.isNew ? collectionUrl(item) : url;
  const isNew = isNewExists ? item.isNew : !genuineCollectionUrl;

  return (
    {
      code: item.code,
      url: urlForCollection,
      readStatus: item.readStatus,
      readErrors: item.readErrors,
      saveStatus: item.saveStatus,
      saveErrors: item.saveErrors,
      isEditing: item.isEditing,
      name: item.name,
      isDirty: item.isDirty,
      ...accessControl(role, true, isNew),
    }
  );
};

export const mapStateToProps = ({
  collections: {
    collections,
  },
  auth: {
    role,
  },
}, { category, code, url }) => {
  const item = findResult(collections, category, code)
      || findResult(collections, category, code, 'previousCode');
  return item ? withItem(item, role, url) : withoutItem(role, url);
};

export const mapDispatchToProps = {
  fetchData: fetchCollection,
  updateProperties: updateCollectionProperties,
};

export default CollectionPanelContainer;
